import { Switch, styled } from "@material-ui/core";
import { useIntl } from "react-intl";

const Wrapper = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
});

type Props = {
  rowId: string;
  active: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
};

export const InlineActiveCell: FC<Props> = ({
  rowId,
  active,
  onChange,
  disabled,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Wrapper onClick={(e) => e.stopPropagation()}>
      <Switch
        size="small"
        checked={active}
        disabled={disabled}
        onChange={(_event, next) => onChange(next)}
        inputProps={{
          "aria-label": formatMessage({
            id: "priceList.inlineActive.toggle",
            defaultMessage: "Toggle active",
          }),
        }}
        data-testid={`priceList.row.${rowId}.active`}
      />
    </Wrapper>
  );
};
